(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  const jump = () => { const hash = window.location.hash.slice(1); if (!hash) return; const target = document.getElementById(hash === 'duo-amis' ? 'duo-couple' : hash); if (target) target.scrollIntoView({behavior:'auto',block:'start'}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', jump, {once:true}); else jump();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unico-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unico-home')) {
  customElements.define('unico-home', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.u-hero-track');
      this.slides = Array.from(this.querySelectorAll('[data-hero]'));
      this.index = 0;
      const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.loadCategoryFrame = image => {
        if (!image) return;
        if (image.dataset.unicoSrcset) { image.srcset = image.dataset.unicoSrcset; delete image.dataset.unicoSrcset; }
        if (image.dataset.unicoSrc) { image.src = image.dataset.unicoSrc; delete image.dataset.unicoSrc; }
      };
      this.categoryStates = [];
      this.categoryWaveTimers = new Set();
      this.categoryObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = this.categoryStates.find(item => item.card === entry.target);
          if (state) { state.visible = entry.isIntersecting && entry.intersectionRatio >= .35; if (state.visible) { this.loadCategoryFrame(state.frames[state.index]); this.loadCategoryFrame(state.frames[(state.index + 1) % state.frames.length]); } }
        });
      }, {threshold: [0, .35]});
      this.querySelectorAll('[data-category]').forEach(card => {
        const frames = [...card.querySelectorAll('.u-category-frame')];
        const button = card.querySelector('[data-category-pause]');
        if (frames.length < 2 || !button) return;
        const column = [...card.parentElement.children].indexOf(card);
        const state = {card, frames, column, index: 0, visible: false, paused: false, hover: false};
        this.categoryStates.push(state);
        button.hidden = false;
        button.addEventListener('click', () => {
          state.paused = !state.paused;
          button.setAttribute('aria-pressed', String(state.paused));
          button.setAttribute('aria-label', state.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
          button.firstElementChild.textContent = state.paused ? '▶' : 'Ⅱ';
        }, {signal});
        card.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') state.hover = true; }, {signal});
        card.addEventListener('pointerleave', () => { state.hover = false; }, {signal});
        this.categoryObserver.observe(card);
      });
      this.categoryTimer = setInterval(() => {
        if (document.hidden || reduced()) return;
        this.categoryStates.forEach(state => {
          const timer = setTimeout(() => {
            this.categoryWaveTimers.delete(timer);
            if (document.hidden || reduced() || !state.card.isConnected || !state.visible || state.paused || state.hover || state.card.contains(document.activeElement)) return;
            const next = (state.index + 1) % state.frames.length;
            const image = state.frames[next];
            this.loadCategoryFrame(image);
            if (!image.complete || !image.naturalWidth) return;
            state.frames[state.index].classList.remove('is-current');
            image.classList.add('is-current');
            state.index = next;
            this.loadCategoryFrame(state.frames[(next + 1) % state.frames.length]);
          }, state.column * 250);
          this.categoryWaveTimers.add(timer);
        });
      }, 5000);
      this.go = (index, instant = false) => {
        if (!this.track || !this.slides.length) return;
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({left: this.slides[target].offsetLeft - this.slides[0].offsetLeft, behavior: instant || reduced() ? 'auto' : 'smooth'});
      };
      const controls = this.querySelector('[data-hero-pause]');
      if (controls && this.track) {
        controls.hidden = false;
        this.querySelectorAll('[data-hero-dot]').forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.heroDot)), {signal}));
        this.heroPaused = false;
        this.heroVisible = false;
        this.heroVisibility = new IntersectionObserver(entries => { this.heroVisible = entries[0].isIntersecting; }, {threshold:.25});
        this.heroVisibility.observe(this.track);
        controls.addEventListener('click', () => {
          this.heroPaused = !this.heroPaused;
          controls.setAttribute('aria-pressed', String(this.heroPaused));
          controls.setAttribute('aria-label', this.heroPaused ? controls.dataset.playLabel : controls.dataset.pauseLabel);
          controls.firstElementChild.textContent = this.heroPaused ? '▶' : 'Ⅱ';
        }, {signal});
        this.track.addEventListener('pointerenter', event => {if(event.pointerType === 'mouse') this.heroHover = true;}, {signal});
        this.track.addEventListener('pointerleave', () => {this.heroHover = false;}, {signal});
        this.heroTimer = setInterval(() => {
          if(document.hidden || reduced() || !this.heroVisible || this.heroPaused || this.heroHover || this.heroEditing || this.track.contains(document.activeElement)) return;
          this.go((this.index + 1) % this.slides.length);
        }, 3000);
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.direction)), {signal}));
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));}
        }, {signal});
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio > .55) {this.index = this.slides.indexOf(entry.target);this.updateControls();}
          });
        }, {root: this.track, threshold: [.55, .8]});
        this.slides.forEach(slide => this.observer.observe(slide));
        this.updateControls();
      }
      document.addEventListener('shopify:block:select', event => {
        const slide = this.slides.find(item => item.dataset.blockId === event.detail.blockId);
        if (slide) {this.heroEditing = true;this.go(this.slides.indexOf(slide),true);}
      }, {signal});
      document.addEventListener('shopify:block:deselect', () => {this.heroEditing = false;}, {signal});
      window.addEventListener('pageshow', () => this.updateControls(), {signal});
    }
    updateControls() {
      this.querySelectorAll('[data-hero-dot]').forEach(button => button.setAttribute('aria-current',String(Number(button.dataset.heroDot) === this.index)));
      const counter = this.querySelector('[data-counter]');if (counter) counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      const previous = this.querySelector('[data-direction="-1"]'),next = this.querySelector('[data-direction="1"]');
      if (previous) previous.disabled = this.index === 0;if (next) next.disabled = this.index === this.slides.length - 1;
    }
    disconnectedCallback() {
      this.abort?.abort();this.abort=null;this.observer?.disconnect();this.categoryObserver?.disconnect();clearInterval(this.categoryTimer);clearInterval(this.heroTimer);this.heroVisibility?.disconnect();this.categoryWaveTimers?.forEach(clearTimeout);this.categoryWaveTimers?.clear();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unico-signature-header"]) return;
  try {
    
if (!customElements.get('unico-navigation')) {
 customElements.define('unico-navigation', class extends HTMLElement {
  connectedCallback() {
   if(this.abort) return;
   this.abort = new AbortController();
   const signal = this.abort.signal;
      const header = this.querySelector('.u-header');
      const dropdowns = Array.from(this.querySelectorAll('.u-dropdown, .u-mobile-menu'));
      const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.menuTimers = new Set();
      const later = (fn, ms) => { const timer = setTimeout(() => { this.menuTimers.delete(timer); fn(); }, ms); this.menuTimers.add(timer); return timer; };
      const cancel = timer => { clearTimeout(timer); this.menuTimers.delete(timer); };
      const sync = () => header?.classList.toggle('is-menu-open', dropdowns.some(item => item.open));
      const close = item => { item.open = false; item.dataset.hoverOpen = ''; sync(); };
      const open = item => { dropdowns.forEach(other => { if (other !== item) close(other); }); item.open = true; sync(); };
      dropdowns.forEach(item => {
        const summary = item.querySelector(':scope > summary');
        summary.addEventListener('click', event => {
          event.preventDefault();
          if (item.dataset.hoverOpen === 'true' && event.detail !== 0) { item.dataset.hoverOpen = ''; open(item); }
          else if (item.open) close(item);
          else open(item);
        }, {signal});
        item.addEventListener('toggle', sync, {signal});
        item.addEventListener('focusout', event => {
          if (!item.contains(event.relatedTarget) && !item.matches(':hover')) close(item);
        }, {signal});
        if (!item.classList.contains('u-dropdown')) return;
        let enterTimer, leaveTimer;
        item.addEventListener('pointerenter', event => {
          if (!hover.matches || event.pointerType === 'touch') return;
          cancel(leaveTimer);
          enterTimer = later(() => { if (!item.open) { item.dataset.hoverOpen = 'true'; open(item); } }, 120);
        }, {signal});
        item.addEventListener('pointerleave', event => {
          if (!hover.matches || event.pointerType === 'touch') return;
          cancel(enterTimer);
          leaveTimer = later(() => { if (!item.contains(document.activeElement)) close(item); }, 240);
        }, {signal});
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const item = event.target.closest('.u-dropdown[open], .u-mobile-menu[open]');
        if (item) { event.preventDefault(); close(item); item.querySelector('summary')?.focus(); }
      }, {signal});
      document.addEventListener('click', event => dropdowns.forEach(item => {
        if (item.open && !item.contains(event.target)) close(item);
      }), {signal});
      const announcement = this.querySelector('.u-announcement');
      const sectionWrapper = this.closest('.shopify-section');
      const mobile = window.matchMedia('(max-width: 749px)');
      let dimensionsDirty = true;
      let navHeight = -1;
      let fixedHeight = -1;
      let headerHeight = -1;
      let scrolled;
      const updateHeader = () => {
        this.headerFrame = null;
        const overlay = this.hasAttribute('data-home-overlay') && !mobile.matches;
        const nextScrolled = !overlay || window.scrollY > 24;
        if (dimensionsDirty) {
          dimensionsDirty = false;
          const nextFixedHeight = this.offsetHeight;
          const nextHeaderHeight = header ? header.offsetHeight : 0;
          const nextNavHeight = overlay ? (announcement ? announcement.offsetHeight : 0) : nextFixedHeight;
          if (nextHeaderHeight !== headerHeight) {
            headerHeight = nextHeaderHeight;
            header?.style.setProperty('--u-header-size', `${headerHeight}px`);
          }
          if (nextNavHeight !== navHeight) {
            navHeight = nextNavHeight;
            sectionWrapper?.style.setProperty('--unico-nav-space', `${navHeight}px`);
          }
          if (nextFixedHeight !== fixedHeight) {
            fixedHeight = nextFixedHeight;
            document.documentElement.style.setProperty('--unico-fixed-header-height', `${fixedHeight}px`);
          }
        }
        if (nextScrolled !== scrolled) {
          scrolled = nextScrolled;
          header?.classList.toggle('is-scrolled', scrolled);
        }
      };
      const onScroll = () => { if (!this.headerFrame) this.headerFrame = requestAnimationFrame(updateHeader); };
      const resizeHeader = () => { dimensionsDirty = true; onScroll(); };
      window.addEventListener('scroll', onScroll, {signal, passive:true});
      window.addEventListener('resize', () => { dropdowns.forEach(close); resizeHeader(); }, {signal});
      if (window.ResizeObserver && header) {
        this.headerResize = new ResizeObserver(resizeHeader);
        this.headerResize.observe(this);
        this.headerResize.observe(header);
        if (announcement) this.headerResize.observe(announcement);
      }
      onScroll();

   const announcementArea = this.querySelector('[data-announcements]');
   const announcements = [...this.querySelectorAll('[data-announcement]')];
   const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
   let announcementIndex = 0;
   const stopAnnouncements = () => { clearInterval(this.announcementTimer); this.announcementTimer = null; };
   const startAnnouncements = () => {
     stopAnnouncements();
     if (announcements.length < 2 || reducedMotion.matches || document.hidden || announcementArea?.matches(':hover, :focus-within')) return;
     this.announcementTimer = setInterval(() => {
       announcements[announcementIndex].hidden = true;
       announcementIndex = (announcementIndex + 1) % announcements.length;
       announcements[announcementIndex].hidden = false;
       resizeHeader();
     }, Number(announcementArea.dataset.interval || 3) * 1000);
   };
   announcementArea?.addEventListener('mouseenter', stopAnnouncements, {signal});
   announcementArea?.addEventListener('mouseleave', startAnnouncements, {signal});
   announcementArea?.addEventListener('focusin', stopAnnouncements, {signal});
   announcementArea?.addEventListener('focusout', () => requestAnimationFrame(startAnnouncements), {signal});
   document.addEventListener('visibilitychange', startAnnouncements, {signal});
   reducedMotion.addEventListener('change', startAnnouncements, {signal});
   startAnnouncements();

   const refreshCart = async () => {
    clearTimeout(this.cartTimer);
    this.cartTimer = setTimeout(async () => {
     try {
      const response = await fetch(`${this.querySelector('.u-cart').getAttribute('href')}.js`, {signal, headers:{Accept:'application/json'}});
      if(!response.ok) return;
      const cart = await response.json();
      if(!Number.isFinite(cart.item_count)) return;
      const link = this.querySelector('.u-cart');
      const badge = link.querySelector('[data-cart-count]');
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
      link.setAttribute('aria-label', `${link.dataset.cartLabel} (${cart.item_count})`);
     } catch(error) { }
    }, 80);
   };
   ['cart:update','cart:updated','cart:change','cart:refresh','cart:added','cart-section:restored'].forEach(name => document.addEventListener(name, refreshCart, {signal}));
   window.addEventListener('pageshow', refreshCart, {signal});
   document.addEventListener('visibilitychange', () => { if(!document.hidden) refreshCart(); }, {signal});
  }
  disconnectedCallback() {
   this.abort?.abort();this.abort=null;
   this.headerResize?.disconnect();
   this.menuTimers?.forEach(clearTimeout);
   clearTimeout(this.cartTimer);
   clearInterval(this.announcementTimer);
   cancelAnimationFrame(this.headerFrame);
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
